import { DesignItemOriginTypes, DesignItemResponseDTO } from '@luminovo/http-client';
import { BomItem } from './bomItemFrontendTypes';

export function isPcbDesignItem(item: DesignItemResponseDTO | BomItem): boolean {
    return item.origin.type === DesignItemOriginTypes.PCB;
}
